import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => void (require(['@/view/index.vue'], resolve))
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => void (require(['@/view/login.vue'], resolve))
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => void (require(['@/view/register.vue'], resolve))
    },
    {
      path: '/detail/:id',
      name: 'detail',
      props: true,
      component: resolve => void (require(['@/view/detail.vue'], resolve))
    },
    {
      path: '/user',
      name: 'user',
      component: resolve => void (require(['@/view/user.vue'], resolve))
    },
    {
      path: '/orders',
      name: 'orders',
      component: resolve => void (require(['@/view/orders.vue'], resolve))
    },
    {
      path: '/order/:order_no',
      name: 'order_detail',
      props: true,
      component: resolve => void (require(['@/view/order_detail.vue'], resolve))
    },
    {
      path: '/grant',
      name: 'grant',
      component: resolve => void (require(['@/view/grant.vue'], resolve))
    },
    {
      path: '/password',
      name: 'password',
      component: resolve => void (require(['@/view/password.vue'], resolve))
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js